import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { getWithParentCategary } from "../../../../redux/categary/action";

export default function ModelCategory({
  formData,
  category,
  setFormData,
  setSubCategory,
  setModalCategory,
}) {
  const dispatch = useDispatch();
  const transformedCategory = {
    value: category?.id || formData?.category_index?.value,
    label: category?.title || formData?.category_index?.label || 'Select Category',
  };

  const [tempCategory, setTempCategory] = useState(transformedCategory);
  const [categorylist, setCategoryList] = useState("");

  const categarylist = useSelector(
    ({ categary: { categarylist } }) => categarylist,
  );

  useEffect(() => {
    formData.industry_id && dispatch(getWithParentCategary(formData.industry_id));
  }, [formData?.industry_id]);

  useEffect(() => {
    setCategoryList(categarylist);
  }, [categarylist]);

  const handleValues = (options) => {
    setTempCategory(options);
  };

  const handleSave = () => {
    if (tempCategory) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        category_index: tempCategory,
        category_id: tempCategory.value,
        subcategory_index: "",
        sub_category_id: "",
      }));
      // setSubCategory("")
    }
    setModalCategory((state) => !state);
  };

  return (
    <>
      <button
        onClick={() => setModalCategory((state) => !state)}
        className ="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Edit Category</h4>
        <ReactSelect
          options={
            Array.isArray(categorylist) &&
            categorylist.map((lang) => ({ value: lang.id, label: lang.title }))
          }
          placeholder="Select Category"
          value={tempCategory}
          onChange={(options) => {
            if (options) {
              handleValues(options);
            }
          }}
        />
      </ModalBody>
      <div className ="modal-footer">
        <button className ="btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </>
  );
}
